import {
    AfterViewInit, booleanAttribute,
    Component,
    ContentChild,
    ElementRef,
    HostBinding,
    Input,
} from '@angular/core';
import {UiButtonComponent} from '../ui-button/ui-button.component';

/**
 * Componente de notificação (Usar em uma única div para evitar bugs)
 */
@Component({
    selector: 'ui-highlight',
    templateUrl: './ui-highlight.component.html',
    styleUrls: ['./ui-highlight.component.scss'],
    standalone: false
})
export class UiHighlightComponent implements AfterViewInit {
    @Input({transform: booleanAttribute}) show = false;
    @Input() text: string | number = null;
    @Input() behaviour: 'always-show' | 'show-on-hover' | 'only-alert' = 'always-show';

    @ContentChild(UiButtonComponent) button?: UiButtonComponent;

    constructor(private el: ElementRef) {
    }

    ngAfterViewInit() {
        const el = this.el.nativeElement as HTMLElement;
        const children = Array.from(el?.children ?? []);

        if (children.length === 2 && this.show) {
            el.style.borderRadius = getComputedStyle(children[0]).borderRadius;

            const observer = new MutationObserver(() => {
                el.style.borderRadius = getComputedStyle(children[0]).borderRadius;
            });
            observer.observe(children[0], {
                attributes: true,
                attributeFilter: ['style', 'class']});
        } else if ((children.length === 2  && !this.show) || children.length >= 2) {
            throw new Error('UiHighlightComponent deve haver somente um elemento filho');
        }
    }

    @HostBinding('class')
    get hostClasses() {
        const classes = [
            this.show && 'ui-highlight-show'
        ];

        return classes.filter(Boolean).join(' ');
    }

    @HostBinding('style.border-radius')
    get hostBorderRadius() {
        if (this.show) {
            const el = this.el.nativeElement as HTMLElement;
            const children = Array.from(el?.children ?? []);

            if (children.length === 2) {
                return getComputedStyle(children[0]).borderRadius;
            }
        }
    }
}
